import {createFileRoute} from '@tanstack/react-router';

import {TagLibrary} from '@/features/Library/components/Tag/TagLibrary';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/tags')({
  component: TagLibrary,
  beforeLoad: () => makeDocumentTitle('Tags'),
});
